window.contributionDetailFormatter = function(value, row) {
    let html = '';
    if (parseInt(row.discount_percentage, 10) === 0) {
        html += '<div class="row py-1">';
        html += '<div class="col-12 col-md-1">&euro; '+row.calculate_without_discount_formatter+'</div>';
        html += '<div class="col-12 col-md-11">'+__('Contribution')+'</div>';
        html += '</div>';
    } else {
        html += '<div class="row py-1">';
        html += '<div class="col-12 col-md-1">&euro; '+row.calculate_without_discount_formatter+'</div>';
        html += '<div class="col-12 col-md-11">'+__('Contribution without discount')+'</div>';
        html += '</div>';
        html += '<div class="row py-1">';
        html += '<div class="col-12 col-md-1">&euro; '+row.calculate_with_discount_formatter+'</div>';
        html += '<div class="col-12 col-md-11">'+__('Contribution with discount')+' '+'('+row.discount_percentage+'%'+')'+'</div>';
        html += '</div>';
    }
    if (row.calculate_without_discount < 121 || row.calculate_with_discount < 121) {
        html += '<p class="fw-bold">'+__('The minimum amount of &euro; 100,- excl. vat applies.')+'</p>';
    }
    return html;
};
